var muteLinks = function (event) {
  event.preventDefault(event);
  event.stopPropagation(event);
};

var links = document.querySelectorAll('.glide__slide > a');
var SeriesContainer = document.querySelector('.Series');
var layoutClass = SeriesContainer.classList[SeriesContainer.classList.length - 1];
var glide = new Glide('.glide', {
  type: 'carousel',
  perView: 1,
});

var initSlider = function (event) {
  var sliderButtons = document.querySelectorAll( '.glide__arrows' );
  /* var assets = document.querySelectorAll('.JS_addToPDF'); */
  SeriesContainer.classList.toggle(layoutClass);
  event.stopPropagation(event);
  event.preventDefault(event);
  sliderButtons.forEach(function(el) {
    el.classList.toggle('u-none');
  });
  SeriesContainer.scrollIntoView( {block: "end", inline: "nearest", behavior: 'smooth' } );
  /* [].forEach.call(assets, function(elem) {
    elem.querySelector('.add').textContent = "Add to PDF";
    elem.querySelector('.remove').textContent = "Remove from PDF";
  }); */
  [].forEach.call(links, function(elem, index) {
    elem.removeEventListener('click', initSlider);
    elem.addEventListener('click', muteLinks);
  });
  glide.update({ startAt: this.dataset.index });
  glide.mount();
};

[].forEach.call(links, function(elem, index) {
    elem.addEventListener('click', initSlider);
});

var toggleViewButton = document.querySelector( '.js-SwitchSeriesView' );

var destroySlider = function ( event ) {
  // var sliderButtons = document.querySelectorAll( '.glide__arrows' );
  var SwiperInstance = document.querySelector('.glide');
  var assets = document.querySelectorAll('.JS_addToPDF');
  glide.destroy();
  SeriesContainer.classList.toggle(layoutClass);
/*   sliderButtons.forEach(function(el) {
    el.classList.toggle('u-none');
  }); */
/*   [].forEach.call(assets, function(elem) {
    elem.querySelector('.add').textContent = "PDF";
    elem.querySelector('.remove').textContent = "X";
  }); */
  [].forEach.call(links, function(elem, index) {
    elem.addEventListener('click', initSlider);
  });
  glide = new Glide('.glide', {
    type: 'carousel',
    perView: 1,
  });
};

toggleViewButton.addEventListener('click', destroySlider, false);